import { useState } from 'react';

const faqs = [
  {
    q: '福岡市内への出張買取は費用がかかりますか？',
    a: '出張費・査定費は完全無料です。福岡市内はもちろん、福岡県全域への出張に対応しており、一切費用はかかりません。査定後に売却しないことも可能です。',
  },
  {
    q: '貴金属の買取はどのように査定しますか？',
    a: '金・プラチナ・シルバーなどの貴金属は、専用の計量器と純度測定器を使用して正確に査定します。市場の金相場に基づいた適正価格でご提示します。',
  },
  {
    q: 'ブランド品の買取で高く売るコツはありますか？',
    a: '付属品（箱・保証書・ギャランティカード）が揃っているほど査定額が上がります。また、クリーニングせずそのままお持ちいただくことをおすすめします。',
  },
  {
    q: '出張買取の当日に必要なものはありますか？',
    a: '身分証明書（運転免許証・マイナンバーカード・パスポート等）が必要です。古物営業法の規定により、ご本人確認をお願いしております。',
  },
  {
    q: '複数のお品物をまとめて売ることはできますか？',
    a: 'もちろん可能です。まとめてお売りいただく場合、状況によって特別査定をご提示できる場合があります。大量の場合もお気軽にご相談ください。',
  },
  {
    q: '査定額に納得できなかった場合はどうなりますか？',
    a: '査定額にご納得いただけない場合は、売却しなくても構いません。キャンセル料・出張費は一切かかりませんのでご安心ください。',
  },
];

export default function TenjinFaq() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section id="faq" className="py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col items-center text-center mb-16">
          <span className="text-xs tracking-[0.3em] text-amber-600 font-medium uppercase mb-3">FAQ</span>
          <h2 className="text-4xl md:text-5xl font-serif text-gray-900 mb-4">よくある質問</h2>
          <div className="w-16 h-0.5 bg-amber-400/50 mx-auto mb-4"></div>
          <p className="text-sm text-gray-500">天神屋の出張買取に関するよくある質問をまとめました</p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, idx) => (
            <div key={idx} className="bg-white rounded-xl overflow-hidden">
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between px-7 py-5 text-left cursor-pointer hover:bg-amber-50/50 transition-colors"
              >
                <div className="flex items-start gap-4">
                  <span className="text-amber-500 font-serif font-bold text-lg flex-shrink-0 mt-0.5">Q</span>
                  <span className="text-sm font-medium text-gray-800 leading-relaxed">{faq.q}</span>
                </div>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 ml-4 transition-transform duration-200 ${openIdx === idx ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-amber-500 text-lg"></i>
                </div>
              </button>
              {openIdx === idx && (
                <div className="px-7 pb-5">
                  <div className="flex items-start gap-4 pt-3 border-t border-gray-100">
                    <span className="text-gray-400 font-serif font-bold text-lg flex-shrink-0 mt-0.5">A</span>
                    <p className="text-sm text-gray-600 leading-relaxed mt-0.5">{faq.a}</p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
